import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-main-title',
    templateUrl: './main-title.component.html',
})
export class MainTitleComponent {
    public readonly actionClicked = output<void>();
    public readonly icon = input<IconProp>();
    public readonly iconColor = input<string>();
    public readonly iconSize = input<SizeProp>();
    public readonly isIconAction = input<boolean>(false);
    public readonly subtitle = input<string>();
    public readonly title = input.required<string>();
    public readonly titleSize = input<string>();

    protected onIconClick(): void {
        if (!this.isIconAction()) {
            return;
        }
        this.actionClicked.emit();
    }
}
